// 그레이박스 조각을 정점 색으로 칠해 하나로 병합한다(드로우콜 절약).
import * as THREE from 'three/webgpu';
import { mergeGeometries } from 'three/addons/utils/BufferGeometryUtils.js';

/** 조각에 정점 색을 입히고 위치를 옮긴다. */
export function colored(g: THREE.BufferGeometry, hex: number, tx = 0, ty = 0, tz = 0): THREE.BufferGeometry {
  g.translate(tx, ty, tz);
  const c = new THREE.Color(hex);
  const n = g.getAttribute('position').count;
  const col = new Float32Array(n * 3);
  for (let i = 0; i < n; i++) {
    col[i * 3] = c.r;
    col[i * 3 + 1] = c.g;
    col[i * 3 + 2] = c.b;
  }
  g.setAttribute('color', new THREE.BufferAttribute(col, 3));
  return g;
}

export function merge(parts: THREE.BufferGeometry[]): THREE.BufferGeometry {
  // 다면체(색인 없음)와 상자·원기둥(색인 있음)이 섞이면 모두 색인 없이 맞춘다(섞이면 mergeGeometries가 실패한다)
  if (parts.some((p) => p.index) && parts.some((p) => !p.index)) parts = parts.map((p) => { if (!p.index) return p; const n = p.toNonIndexed(); p.dispose(); return n; });
  const g = mergeGeometries(parts, false);
  if (!g) throw new Error('지오메트리 병합 실패');
  for (const p of parts) p.dispose();
  return g;
}
